import { Box, Button, Container, Link } from "@mui/material";
import { useWhitelabel } from "../context/WhitelabelContext";
import { getInstanceConfig, getLogoMode } from "../utils";

export default function Header({
  mode,
  maxWidth = "xl",
}: {
  mode: string;
  maxWidth: any;
}) {
  const { whitelabelSettings, whitelabelLogos } = useWhitelabel();
  const instanceConfig = getInstanceConfig(mode, whitelabelSettings);

  // Determine logo source - use whitelabel horizontal logo if available, otherwise default
  const logoSrc = whitelabelLogos?.horizontal_logo?.publicUrl || getLogoMode(mode);
  const logoAlt = instanceConfig.title ? `${instanceConfig.title} logo` : "GTM AI logo";

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <Container style={{ display: "flex" }} maxWidth={maxWidth}>
        <Link href="/">
          <Box
            component="img"
            src={logoSrc}
            alt={logoAlt}
            style={{
              height: 35,
              marginTop: 5,
              marginRight: 10,
            }}
          />
        </Link>
        <div style={{ flexGrow: 1 }}></div>
        <Button
          component={Link}
          href="/login"
          style={{ 
            marginRight: 15, 
            marginTop: 10,
            color: instanceConfig.primaryColor || undefined
          }}
        >
          Login
        </Button>
        <Button
          variant="outlined"
          component={Link}
          href="/signup"
          style={{ 
            marginRight: 20, 
            marginTop: 10,
            borderColor: instanceConfig.primaryColor || undefined,
            color: instanceConfig.primaryColor || undefined
          }}
        >
          Sign Up
        </Button>
      </Container>
    </Box>
  );
}
